import { LanguagesAbbr } from "../types/working-model";
import { GetHv } from "./helpers";

export const FetchModuleQuestions = (module_id: number, language: LanguagesAbbr, token: string): Promise<any> => (
	GetHv(`/e3-get-module-questions/${module_id}/${language}`, token)
);

export const FetchQuestionComments = (questionId: number, token: string, page = 0): Promise<any> => (
	GetHv(`/e3-get-questions-comments/${questionId}?page=${page}`, token)
);
